const getTimezoneOfAddress = (address) =>
  (address && address.timezone) || false;

export default getTimezoneOfAddress;
